import styled from 'styled-components/macro'

import Typography from '@material-ui/core/Typography'

const H1 = styled(Typography)`
  font-size: 1.6rem;
`

export default H1
